// src/components/Dashboard/UpcomingBirthdays.jsx
import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import notificationService from '../../services/notification.service';

const UpcomingBirthdays = () => {
  const { isSuperAdmin } = useAuth();
  const [list, setList]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const companyId = isSuperAdmin ? localStorage.getItem('selectedCompanyId') : null;
    notificationService.getUpcomingBirthdays(companyId)
      .then(res => { if (res.success) setList(res.data || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [isSuperAdmin]);

  const fmt = (dob) => {
    const d = new Date(dob);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
  };

  const isToday = (dob) => {
    const d = new Date(dob), t = new Date();
    return d.getMonth() === t.getMonth() && d.getDate() === t.getDate();
  };

  return (
    <div className="db-card">
      <div className="db-card-header">
        <h6 className="db-card-title">🎂 Upcoming Birthdays</h6>
      </div>
      {loading ? (
        <p style={{ color: '#adb5a0', fontSize: 13, textAlign: 'center', padding: '20px 0' }}>Loading...</p>
      ) : list.length === 0 ? (
        <p style={{ color: '#adb5a0', fontSize: 13, textAlign: 'center', padding: '20px 0' }}>
          No birthdays in the next 15 days
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {list.map(p => (
            <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{
                width: 38, height: 38, borderRadius: '50%', background: '#e8f5e9',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#2e7d32', fontWeight: 700, fontSize: 14, flexShrink: 0,
              }}>
                {p.avatar
                  ? <img src={p.avatar} alt="" style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover' }} />
                  : `${p.firstName?.[0] || ''}${p.lastName?.[0] || ''}`.toUpperCase()}
              </div>
              <div style={{ flexGrow: 1, minWidth: 0 }}>
                <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: '#333' }}>
                  {p.firstName} {p.lastName}
                </p>
                <p style={{ margin: 0, fontSize: 12, color: '#888' }}>
                  {p.employeeCode || ''}
                </p>
              </div>
              <span style={{
                fontSize: 12, fontWeight: 600,
                color: isToday(p.dateOfBirth) ? '#e53935' : '#2e7d32',
                background: isToday(p.dateOfBirth) ? '#fce4ec' : '#e8f5e9',
                padding: '3px 10px', borderRadius: 12, whiteSpace: 'nowrap',
              }}>
                {isToday(p.dateOfBirth) ? '🎉 Today' : fmt(p.dateOfBirth)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UpcomingBirthdays;